import React, { useState } from 'react'
import {
  Box,
  Toolbar,
  AppBar as MuiAppBar,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Stack,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
// import arvalLogo from 'assets/images/logo-arval.png' // logo Arval rimosso dall'header (vedi richiesta canalizzazione)
import airLogo from 'assets/images/logo-air.png'

import MainToolbarLinks from 'components/atoms/MainToolbarLinks'
import IconButton from 'components/atoms/IconButton'

import { useAuth } from '../../auth'

const classes = {
  title: 'title',
  airLogo: 'air-logo',
  arvalLogo: 'arval-logo',
}
const StyledMuiAppBar = styled(MuiAppBar)(({ theme }) => ({
  [`& .${classes.title}`]: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    borderLeft: '1px solid',
    borderColor: theme.palette.text.hint,
  },
  [`& .${classes.airLogo}`]: {
    paddingRight: theme.spacing(2.5),
    maxWidth: '66px',
  },
}))

export default function AppBar({ authData, authState }) {
  const { t } = useTranslation()
  const { signOut, currentSession } = useAuth()

  const [anchorEl, setAnchorEl] = useState(null)

  const toggleMenu = (e) => setAnchorEl(anchorEl ? null : e.currentTarget)

  const logout = () => signOut()

  const showLogged = !(authState && authState === 'signIn')

  return (
    <StyledMuiAppBar position="fixed" color="secondary">
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Stack direction="row" alignItems="center">
          <Box
            component="img"
            src={airLogo}
            alt={t('common.airName')}
            title={t('common.airName')}
            className={classes.airLogo}
          />
          <Divider orientation="vertical" variant="middle" />
          <Typography
            variant="body2"
            className={classes.title}
            color="textSecondary"
          >
            <strong>
              {t('common.appName')} {t('common.appNameSuffix')}
            </strong>
          </Typography>
        </Stack>
        {showLogged && <MainToolbarLinks />}
        <Stack direction="row" alignItems="center">
          {/* Logo Arval rimosso dall'header su richiesta (canalizzazione Arval). Mantenuto commentato per eventuale ripristino futuro. */}
          {/* <Box
            component="img"
            src={arvalLogo}
            alt={t('common.arvalName')}
            title={t('common.arvalName')}
            className={classes.arvalLogo}
          /> */}
          {showLogged && (
            <div>
              <IconButton
                color="secondary"
                onClick={toggleMenu}
                aria-label="account button"
                size="large"
                sx={{ ml: 2, p: 0.75 }}
                data-testid="button-account"
              >
                <AccountCircleOutlinedIcon />
              </IconButton>
              <Menu
                id="appbar-menu"
                anchorEl={anchorEl}
                keepMounted
                open={!!anchorEl}
                onClose={toggleMenu}
              >
                {!!currentSession && (
                  <MenuItem onClick={logout} data-testid="action-logout">
                    Logout
                  </MenuItem>
                )}
              </Menu>
            </div>
          )}
        </Stack>
      </Toolbar>
    </StyledMuiAppBar>
  )
}

AppBar.propTypes = {
  authData: T.shape({
    username: T.string,
  }),
  authState: T.string,
}
